import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClock = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "currentColor",
	viewBox: "5.4 4.9 22.2 22.2",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16.5 5C10.4249 5 5.5 9.92487 5.5 16C5.5 22.0751 10.4249 27 16.5 27C22.5751 27 27.5 22.0751 27.5 16C27.5 9.92487 22.5751 5 16.5 5ZM6.96667 16C6.96667 10.7349 11.2349 6.46667 16.5 6.46667C21.7651 6.46667 26.0333 10.7349 26.0333 16C26.0333 21.2651 21.7651 25.5333 16.5 25.5333C11.2349 25.5333 6.96667 21.2651 6.96667 16ZM16.5 9.25C16.9142 9.25 17.25 9.58579 17.25 10V15.6893L20.0303 18.4697C20.3232 18.7626 20.3232 19.2374 20.0303 19.5303C19.7374 19.8232 19.2626 19.8232 18.9697 19.5303L15.9697 16.5303C15.8978 16.4584 15.8435 16.3755 15.8069 16.2871C15.7702 16.1987 15.75 16.1017 15.75 16V10C15.75 9.58579 16.0858 9.25 16.5 9.25Z"
	})
});
export { SvgClock as ReactComponent };
